export const zIndexDefine = {
  player: 500,
  modal: 600,
};
